<div class="body-container">
  <div class="login-flex">
    <div class="login-image-part">
      <!-- <img class="side-image login-image" style="width: 300px !important;" id="darkMode" src="/assets/images/LoginDark.svg">
      <img class="side-image login-image" style="width: 300px !important;" id="lightMode" src="/assets/images/loginLight.svg"> -->
      <img class="side-image login-image" style="width: 300px !important;" [src]=" iFrame ? Img.dark : Img.light"
      alt="salons@" />
    </div>
    <div class="login-form-part">
      <mat-card class="m20">
        <h2>
          Contact:
          <a href="mailto:support@visitmaker.com" class="contact-email">support@visitmaker.com</a>
        </h2>
      </mat-card>
    </div>
  </div>
</div>
